import { Badge } from '@material-ui/core';

export const MUIBadge = Badge;
